module.exports = __webpack_public_path__ + "static/media/AdvancedAndroid.7550655f.png";